export const dispatchIntercept = ([_, dispatch], ContextState) => [
  _,
  (action, ...args) => dispatch(action, ...args),
];
